export default __webpack_public_path__ + "static/media/mouseScroll.61e8d6ba.svg";